export const selectSummaryData = (state) => state.tatMonitoringSummary?.summaryData;
export const selectLoading = (state) => state.tatMonitoringSummary?.loading;